import { createContext } from "react";

export interface DashboardContextType {
  selectedDashboardId: string | null;
  setSelectedDashboardId: (id: string | null) => void;
}

export const DashboardContext = createContext<DashboardContextType>({
  selectedDashboardId: null,
  setSelectedDashboardId: () => {},
});
